var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0003 8.33333C33.1503 7.75 31.117 7.5 29.167 7.5C25.917 7.5 22.417 8.16667 20.0003 10C17.5837 8.16667 14.0837 7.5 10.8337 7.5C7.58366 7.5 4.08366 8.16667 1.66699 10V34.4167C1.66699 34.8333 2.08366 35.25 2.50033 35.25C2.66699 35.25 2.75033 35.1667 2.91699 35.1667C5.16699 34.0833 8.41699 33.3333 10.8337 33.3333C14.0837 33.3333 17.5837 34 20.0003 35.8333C22.2503 34.4167 26.3337 33.3333 29.167 33.3333C31.917 33.3333 34.7503 33.8333 37.0837 35.0833C37.2503 35.1667 37.3337 35.1667 37.5003 35.1667C37.917 35.1667 38.3337 34.75 38.3337 34.3333V10C37.3337 9.25 36.2503 8.75 35.0003 8.33333ZM35.0003 30.8333C33.167 30.25 31.167 30 29.167 30C26.3337 30 22.2503 31.0833 20.0003 32.5V13.3333C22.2503 11.9167 26.3337 10.8333 29.167 10.8333C31.167 10.8333 33.167 11.0833 35.0003 11.6667V30.8333Z",
    fill: "url(#paint0_linear_1125_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.167 17.5C30.6337 17.5 32.0503 17.65 33.3337 17.9333V15.4C32.017 15.15 30.6003 15 29.167 15C26.3337 15 23.767 15.4833 21.667 16.3833V19.15C23.5503 18.0833 26.167 17.5 29.167 17.5Z",
    fill: "url(#paint1_linear_1125_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.667 20.8167V23.5833C23.5503 22.5167 26.167 21.9333 29.167 21.9333C30.6337 21.9333 32.0503 22.0833 33.3337 22.3667V19.8333C32.017 19.5833 30.6003 19.4333 29.167 19.4333C26.3337 19.4333 23.767 19.9333 21.667 20.8167Z",
    fill: "url(#paint2_linear_1125_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.167 23.8833C26.3337 23.8833 23.767 24.3666 21.667 25.2666V28.0333C23.5503 26.9666 26.167 26.3833 29.167 26.3833C30.6337 26.3833 32.0503 26.5333 33.3337 26.8166V24.2833C32.017 24.0166 30.6003 23.8833 29.167 23.8833Z",
    fill: "url(#paint3_linear_1125_991)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_991",
    x1: 20.0003,
    y1: 7.5,
    x2: 20.0003,
    y2: 35.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1125_991",
    x1: 27.5003,
    y1: 15,
    x2: 27.5003,
    y2: 19.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1125_991",
    x1: 27.5003,
    y1: 19.4333,
    x2: 27.5003,
    y2: 23.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1125_991",
    x1: 27.5003,
    y1: 23.8833,
    x2: 27.5003,
    y2: 28.0333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBook);
export default __webpack_public_path__ + "static/media/menuBook.429b233c683352037094a9d1f29c7a75.svg";
export { ForwardRef as ReactComponent };